import axios from "axios";

const API = axios.create({
  baseURL: "https://zeus.vwu.edu/~jjpepper/CS489Project/api/"
});

/* =========================
   AUTO ATTACH TOKEN
========================= */

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

/* =========================
   AUTO LOGOUT ON EXPIRED TOKEN
========================= */

API.interceptors.response.use(
  (res) => res,

  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");

      // redirect to login
      window.location.href = "/";
    }

    return Promise.reject(err);
  }
);

/* =========================
   AUTH
========================= */

export const register = (data) =>
  API.post("/register.php", data);

export const login = (data) =>
  API.post("/login.php", data);

/* =========================
   BOARDS
========================= */

export const getBoards = () =>
  API.get("/getBoards.php");

export const createBoard = (data) =>
  API.post("/createBoard.php", data);

export const deleteBoard = (id) =>
  API.post("/deleteBoard.php", { id });

export const updateBoard = (data) =>
  API.post("/updateBoard.php", data);

/* =========================
   LISTS
========================= */

export const getLists = (boardId) =>
  API.get(`/getLists.php?board_id=${boardId}`);

export const createList = (data) =>
  API.post("/createList.php", data);

export const updateList = (data) =>
  API.post("/updateList.php", data, {
    headers: {
      "Content-Type": "application/json"
    }
  });

export const deleteList = (id) =>
  API.post("/deleteList.php", { id });

/* =========================
   CARDS
========================= */

export const getCards = (listId) =>
  API.get(`/getCards.php?list_id=${listId}`);

export const createCard = (data) =>
  API.post("/createCard.php", data);

export const updateCard = (data) =>
  API.post("/updateCard.php", data, {
    headers: {
      "Content-Type": "application/json"
    }
  });

export const deleteCard = (id) =>
  API.post("/deleteCard.php", { id });

/* =========================
   ADMIN
========================= */

export const getUsers = () =>
  API.get("/admin/getUsers.php");

export const deleteUser = (id) =>
  API.post("/admin/deleteUser.php", { id });

export const makeAdmin = (id) =>
  API.post("/admin/makeAdmin.php", { id });

export default API;